// @flow

// - Stylesheet
import './inscription-step-course.less';

import $        from 'jquery';
import { View } from '@insolus/backbone';

// - Collections
import Courses from 'collections/courses';

// - Models
import Course        from 'models/course';
import CoursesFilter from '../../models/courses-filter';

// - Components
import LoadingView               from '../loading';
import CourseFiltersView         from '../course-filters';
import InscriptionStepCourseItem from '../inscription-step-course-item';

class InscriptionStepCourse extends View {
    get isPrerendered(): boolean { return true; }

    collection: Courses;
    subjectId: ?number;
    LoadingView: ?LoadingView;
    FiltersView: ?CourseFiltersView;

    get events(): Object {
        return {
            'click .inscription-step-course-item'           : 'selectItem',
            'click .inscription-step-course__filter-button' : 'showFilters'
        };
    }

    initialize(options: { subjectId: number }) {
        this.collection  = new Courses();
        this.subjectId   = options.subjectId;
        this.LoadingView = null;
        this.FiltersView = null;

        this.render();
    }

    // ——————————————————————————————————————————————————————
    // —
    // —     Rendering
    // —
    // ——————————————————————————————————————————————————————

    bindElements() {
        this.$filters          = this.$el.element('filters');
        this.$loading          = this.$el.element('loading');
        this.$noCourseMessage  = this.$el.element('no-course-message');
        this.$noPeriod         = this.$el.element('no-period');
        this.$errorMessage     = this.$el.element('error-message');
        this.$results          = this.$el.element('results');
        this.$form             = this.$el.element('form');
        this.$input            = this.$el.element('input');
    }

    onRender() {
        if (!this.LoadingView) {
            this.LoadingView = new LoadingView(this.$loading);
        }

        if (!this.FiltersView) {
            this.FiltersView = new CourseFiltersView({
                el        : this.$filters,
                subjectId : this.subjectId
            });
            this.FiltersView
                .changeElement(this.$filters)
                .on('startFiltering', () => {
                    this.empty();
                    this.$el.removeModifier('empty');
                    this.$el.removeModifier('loaded');
                    this.$el.removeModifier('no-period');
                })
                .on('filterSelected', (filter: CoursesFilter) => {
                    this.loadCourses(filter);
                })
                .on('filterReturn', () => {
                    this.$el.removeModifier('filter-displayed');
                });
        }

        // this.loadCourses();
        this.$el.addModifier('loaded');
        this.$el.addModifier('no-period');
    }

    onDestroy() {
        if (this.FiltersView) {
            this.FiltersView
                .off('startFiltering')
                .off('filterSelected')
                .off('filterReturn');
        }
    }

    // ——————————————————————————————————————————————————————
    // —
    // —     Custom methods
    // —
    // ——————————————————————————————————————————————————————

    empty() {
        this.$results.empty();
        this.$el.removeModifier('with-error');
    }

    loadCourses(filter: ?CoursesFilter) {
        this.empty();
        this.$el.removeModifier('no-period');
        this.$el.removeModifier('loaded');

        const filterModel: CoursesFilter = filter || new CoursesFilter({
            subjectId: this.subjectId
        });

        const data: Object = filterModel.attributes;
        data.queryType     = 'inscriptions';

        if (!data.period || data.period.length === 0) {
            this.collection.reset();
            this.$el.addModifier('loaded');
            this.$el.addModifier('no-period');
            return;
        }

        this.collection.fetch({
            data,
            reset   : true,
            success : () => {
                this.$el.addModifier('loaded');
                this._addCourses();
            },
            error: () => {
                this.$el.addModifier('with-error');
                this.$el.addModifier('loaded');
            }
        });
    }

    selectItem(e: JQueryMouseEventObject) {
        const $item: JQuery = $(e.currentTarget);
        this.$input.val($item.data('id'));
        this.$form.submit();
    }

    showFilters() {
        this.$el.addModifier('filter-displayed');
    }

    // ——————————————————————————————————————————————————————
    // —
    // —     Protected methods
    // —
    // ——————————————————————————————————————————————————————

    _addCourses() {
        this.$el.removeModifier('empty');
        if (this.collection.length === 0) {
            this.$el.addModifier('empty');
            return;
        }

        this.collection.each((model: Course) => {
            const courseItem: InscriptionStepCourseItem = new InscriptionStepCourseItem({ model });
            this.$results.append(courseItem.$el);
            courseItem.render();
        });
    }
}

export default InscriptionStepCourse;



// WEBPACK FOOTER //
// ./src/views/themes/front/components/inscription-step-course/inscription-step-course.js